document.addEventListener('alpine:init', () => {
    window.Alpine.data('modalMessage', (config) => ({
        parentModalName: config.parentModalName ?? 'name_missing',
        modalName: config.modalName ?? 'name_missing',
        closeMessageModalOpenParentModal: {
            ['@click'](){
                // open parent modal name
                this.$store.modalStore.currentModalName = this.parentModalName;
            }
        }
    }))
});
